import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { audienceIcons } from '../data/mock';
import { Building, User, UserCircle, Plane } from 'lucide-react';

const iconMap = {
  Building: Building,
  User: User,
  UserCircle: UserCircle,
  Plane: Plane
};

const AudienceSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Clientes
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            {t.audience.title}
          </h2>
          <p className="text-lg text-slate-600">
            {t.audience.subtitle}
          </p>
        </div>

        {/* Audience Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.audience.items.map((item, index) => {
            const IconComponent = iconMap[audienceIcons[index]];
            return (
              <div
                key={item.id}
                className="group relative text-center p-8 bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-slate-100"
              >
                {/* Icon Circle */}
                <div className="w-16 h-16 mx-auto bg-gradient-to-br from-teal-50 to-emerald-50 rounded-full flex items-center justify-center mb-5 group-hover:from-teal-100 group-hover:to-emerald-100 transition-colors">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-teal-600 group-hover:scale-110 transition-transform" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-slate-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-slate-600 text-sm">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
